import { UPDATE_OVAL_MODE, UPDATE_OVAL_WIDTH } from '../actions'

type State = {
  enabled: boolean
  width: string
}

const initialState: State = {
  enabled: true,
  width: '16vw'
}

type TPayload = boolean | string

export default function init (previousState = initialState, { type, payload }: { type: string; payload: TPayload }) {
  if (type === UPDATE_OVAL_MODE) return { ...previousState, enabled: payload }
  else if (type === UPDATE_OVAL_WIDTH) return { ...previousState, width: payload }
  return previousState
}
